import { render, staticRenderFns } from "./particle.vue?vue&type=template&id=32055dc4&scoped=true&"
import script from "./particle.vue?vue&type=script&lang=js&"
export * from "./particle.vue?vue&type=script&lang=js&"
import style0 from "./particle.vue?vue&type=style&index=0&id=32055dc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32055dc4",
  null
  
)

export default component.exports